import React from 'react';
import PropTypes from 'prop-types';

/**
 * SessionsSidebar
 * Layout wrapper for the event day navigation.
 * Handles responsive orientation and scroll behavior via SCSS.
 */
const SessionsSidebar = ({ children }) => {
    return (
        <aside className="sessions-sidebar">
            <div className="sessions-sidebar-wrapper">
                <ul className="sessions-sidebar-list">
                    {children}
                </ul>
            </div>
        </aside>
    );
};

SessionsSidebar.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
};

export default SessionsSidebar;
